import type { StepProps } from '~/lib/types/netlify';
interface DeploymentStepsProps {
  currentStep: number;
}

export const DeploymentSteps = ({ currentStep }: DeploymentStepsProps) => {
  return (
    <div className="flex items-center justify-between">
      <Step step={2} currentStep={currentStep} label="Create Site" />
      <Step step={3} currentStep={currentStep} label="Build" />
      <Step step={4} currentStep={currentStep} label="Deploy" />
    </div>
  );
};

const Step = ({ step, currentStep, label }: StepProps) => {
  const isComplete = currentStep > step || (step === 4 && currentStep === 4);
  const isCurrent = currentStep === step && step !== 4;

  return (
    <div className="flex items-center">
      <div className="relative">
        <div
          className={`w-5 h-5 rounded-full flex items-center justify-center transition-colors duration-200
          ${isComplete ? 'bg-white border-white' : ''}
          ${isCurrent ? 'border-2 border-white bg-transparent' : ''}
          ${!isComplete && !isCurrent ? 'border border-white/20 bg-transparent' : ''}`}
        >
          {isComplete ? (
            <div className="i-ph:check-bold w-3 h-3 text-black" />
          ) : isCurrent ? (
            <div className="w-2 h-2 rounded-full bg-white animate-pulse" />
          ) : null}
        </div>
      </div>
      <div className="ml-3">
        <p
          className={`text-sm font-medium transition-colors duration-200
          ${isComplete || isCurrent ? 'text-white' : 'text-[#888888]'}`}
        >
          {label}
        </p>
      </div>
    </div>
  );
};
